export default __webpack_public_path__ + "static/media/rocket-hideout.b6699d6e.png";